<template>
  <!-- 余额充值 -->
  <div class="Booking">
    <TopNavigation class="topNavigation"></TopNavigation>
    <div class="typeArea">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'UserInfo', params: { menuInx: '5' } }"
          >我的钱包</el-breadcrumb-item
        >
        <el-breadcrumb-item class="bread">余额充值</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="con">
        <div class="shangm">
          <div class="ttt">订好舱余额充值</div>
          <div>在订好舱平台购买会员、进行订舱，发布舱位，可随时提现</div>
        </div>
        <div class="xiam">
          <div class="biaoti">{{ nikename }} 正在进行余额充值</div>
          <div class="cz">
            <div
              v-for="item in payList"
              :key="item.id"
              class="chong"
              @click="Recharge(item)"
              :class="{ 'is-active': chongzhi == item.id }"
            >
              <div class="tiao"></div>
              <div v-if="item.id != 0" class="num">
                ￥<span>{{ item.amount }}</span>
              </div>
              <div class="line"></div>
              <div class="buc">{{ item.remark }}</div>
            </div>
            <div
              class="chong chongLast"
              @click="Recharge('')"
              :class="{ 'is-active': chongzhi == 4 }"
            >
              <div class="tiao"></div>
              <div class="num">
                <div class="input" :class="{ hong: moneyInput.length != 0 }">
                  ￥
                  <el-input
                    min="0"
                    type="number"
                    @input="changeMoney"
                    v-model="moneyInput"
                    @blur="gaibianMoney"
                    placeholder="请输入"
                  ></el-input>
                </div>
              </div>
              <div class="line"></div>
              <div class="buc">可用于购买会员、订舱、发布舱位</div>
            </div>
          </div>
          <div class="xian"></div>

          <div class="zhifu">
            <div class="zf-left">
              <div class="elbutton" 
              @click=" way = 1" 
              :class="{'yue' : way  == 1}">
                <img class="img" v-if="way == 2" src="../../assets/images/smzfHei.png" alt="">
                <img class="img" v-else src="../../assets/images/smzf.png" alt="">
                在线支付
              </div>
              <div class="elbutton"
                @click="way = 2"
                :class="{ yue: way == 2 }"
                >
                  <img class="img" v-if="way == 1" src="../../assets/images/dgzzHei.png" alt="">
                  <img class="img" v-else src="../../assets/images/dgzz.png" alt="">
                  对公转账
              </div>
            </div>
            <div v-if="way == 1" class="zf-right">
              <div class="qian">
                应付金额：
                <span>￥</span>
                <span class="num">{{ money }}</span>
              </div>
              <div class="ye">
                充值后到账￥{{ money }}，可在个人中心 - 我的钱包内查看
              </div>
              <div class="xiaohao">
                <div>
                  <div class="wx">
                    <div v-if="wxImg==''" class="imageNull">加载中</div>
                    <el-image v-else :src="wxImg"></el-image>
                  </div>
                  <div class="wxzf">
                    <!-- <i class="el-icon-eleme"></i> -->
                    <svg t="1749704932720" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5403" width="22" height="22"><path d="M404.511405 600.865957c-4.042059 2.043542-8.602935 3.223415-13.447267 3.223415-11.197016 0-20.934798-6.169513-26.045189-15.278985l-1.959631-4.296863-81.56569-178.973184c-0.880043-1.954515-1.430582-4.14746-1.430582-6.285147 0-8.251941 6.686283-14.944364 14.938224-14.944364 3.351328 0 6.441713 1.108241 8.94165 2.966565l96.242971 68.521606c7.037277 4.609994 15.433504 7.305383 24.464181 7.305383 5.40101 0 10.533914-1.00284 15.328104-2.75167l452.645171-201.459315C811.496653 163.274644 677.866167 100.777241 526.648117 100.777241c-247.448742 0-448.035176 167.158091-448.035176 373.361453 0 112.511493 60.353576 213.775828 154.808832 282.214547 7.582699 5.405103 12.537548 14.292518 12.537548 24.325012 0 3.312442-0.712221 6.358825-1.569752 9.515724-7.544837 28.15013-19.62599 73.202209-20.188808 75.314313-0.940418 3.529383-2.416026 7.220449-2.416026 10.917654 0 8.245801 6.692423 14.933107 14.944364 14.933107 3.251044 0 5.89015-1.202385 8.629541-2.7793l98.085946-56.621579c7.377014-4.266164 15.188934-6.89913 23.790846-6.89913 4.577249 0 9.003048 0.703011 13.174044 1.978051 45.75509 13.159718 95.123474 20.476357 146.239666 20.476357 247.438509 0 448.042339-167.162184 448.042339-373.372709 0-62.451354-18.502399-121.275087-51.033303-173.009356L407.778822 598.977957 404.511405 600.865957z" fill="#09bb07" p-id="5404"></path></svg>
                    <span>微信支付</span>
                  </div>
                </div>
                <!-- <div>
                  <div class="zfb">
                    <el-image></el-image>
                  </div>
                  <div class="zfbzf">
                    <i class="el-icon-eleme"></i>支付宝支付
                  </div>
                </div> -->
              </div>
              <div class="xieyi">
                支付即同意
                <span>《在线支付协议》</span>
              </div>
            </div>
            <div v-if="way == 2" class="zf-right">
              <div class="qian">
                应付金额：
                <span>￥</span>
                <span class="num">{{ money }}</span>
              </div>
              <div class="ye">转账后点击上传支付凭证等待审核</div>
              <div class="huikuan">
                <div class="first">1</div>
                <div>
                  <div class="tit">请汇款至下方账户</div>
                  <div>
                    <span>收款公司：{{ payDetail.collecting_company }}</span>
                    <span>开户行：{{ payDetail.opening_bank }}</span>
                  </div>
                  <div>收款账号：{{ payDetail.account_number }}</div>
                </div>
              </div>
              <div class="huikuan">
                <div class="first">2</div>
                <div>
                  <div class="tit">完成后添加支付凭证</div>
                  <div>
                    <span>
                      支付凭证示例：
                      <button class="btn" @click="dialogSLVisible = true">点击查看</button>
                    </span>
                    <span>
                      上传支付凭证：
                      <button class="btn" @click="dialogFormVisible = true">
                        点击上传
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="xieyi">
                支付即同意
                <span @click="xieyi">《会员服务协议》</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 对话框上传凭证 -->
    <el-dialog
      class="dialog"
      title="上传支付凭证"
      :visible.sync="dialogFormVisible"
    >
      <el-form>
        <el-form-item label="企业名称">
          <el-input
            :disabled="formSubmit.enterprise_name!='' || formSubmit.enterprise_name!=undefined"
            placeholder="请输入认证时的数据"
            v-model="formSubmit.enterprise_name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系邮箱">
          <el-input
           :disabled="formSubmit.email!='' || formSubmit.enterprise_name!= undefined"
            placeholder="请输入认证时的数据"
            v-model="formSubmit.email"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="支付凭证">
          <el-upload
            class="avatar-uploader"
            action="https://dhctest.yunfangshi.com/api/upload/image"
            :show-file-list="false"
            :limit="1"
            :on-success="uploadImgSuccess"
            :headers="headers"
          >
            <img
              v-if="formSubmit.voucher_file"
              :src="formSubmit.voucher_file"
              class="upload"
            />
            <div class="shangchuan" v-else>
              <img src="@/assets/images/update.png" alt="" />
              <div>上传支付凭证</div>
            </div>
          </el-upload>
          <el-button
            v-if="formSubmit.voucher_file"
            class="YlBTN"
            type="text"
            @click="yulan"
            >预览</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="quxiao" @click="dialogFormVisible = false"
          >返回</el-button
        >
        <el-button type="primary" class="queren" @click="dgzzSubmit"
          >提交</el-button
        >
      </div>

      <el-dialog class="yulanImg" append-to-body :visible.sync="dialogVisible">
        <img class="tupp" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </el-dialog>
    <!-- 协议 -->
    <el-dialog
      :title="ratetitle"
      :visible.sync="dialogVisiblexieyi"
      width="30%">
      <!-- <span>{{ratetext}}</span> -->
      <div v-html="ratetext"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblexieyi = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisiblexieyi = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 示例 -->
    <el-dialog
    title="支付凭证示例"
    :visible.sync="dialogSLVisible"
    width="30%"
    >
    <img
      :src="payDetail.payment_voucher"
      class="upload"
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogSLVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogSLVisible = false">确 定</el-button>
    </span>
  </el-dialog>
  </div>
</template>
    
<script>
import { getRechargeAmountList, rechargeConfig, recharge,indexPolicy,getPayQRCode } from "@/api/api";
import TopNavigation from "../HP/TopNavigationB.vue";
export default {
  components: {
    TopNavigation,
  },
  data() {
    return {
      nikename: JSON.parse(localStorage.getItem("userInfo")).nickname,
      form: {
        card: "",
      },
      // 支付方式
      way: 2,
      // 对话框打开状态、
      dialogFormVisible: false,
      // 上传凭证预览
      dialogVisible: false,
      // 支付凭证示例
      dialogSLVisible:false,
      dialogImageUrl: "",
      chongzhi: "1",
      moneyList: [100, 500, 1000],
      // 充值钱数
      money: 0,
      moneyInput: "",
      headers: {
        token: localStorage.getItem("token"),
      },
      payList: [],
      payDetail: {},
      formSubmit: {
        money: "",
        pay_way: "4",
        enterprise_name: JSON.parse(localStorage.getItem('userInfo')).enterprise_name,
        email: JSON.parse(localStorage.getItem('userInfo')).email,
        voucher_file: "",
      },
      dialogVisiblexieyi:false,
      ratetitle:'',
      ratetext:'',
      wxImg:'', //微信支付图片
    };
  },
  methods: {
     // 富文本处理
     showHtml(str) {
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;nbsp;/g, "\u3000");
    },
    // 《会员服务协议》
    async getindexPolicy(){
      try {
        const res = await indexPolicy({type:'service'});
        // const res = await axios.get('https://dhctest.yunfangshi.com/api/index/policy?type=service')
        this.ratetitle = this.showHtml(res.data.title);
        this.ratetext = this.showHtml(res.data.content);
      } catch (error) {
        console.log(error, "获取平台协议失败");
      }
    },
    xieyi(){
      this.dialogVisiblexieyi = true
      this.getindexPolicy()
    },
    xuanz(ind) {
      this.xzInd = ind;
    },
    yulan() {
      this.dialogVisible = true;
      this.dialogImageUrl = this.formSubmit.voucher_file;
    },
    // 选择充值钱数
    Recharge(event) {
      // // this.money=
      if (event == '') {
        this.money = this.moneyInput;
        this.chongzhi = 4;
        if(this.money>0){
          this.getWxImg()
        }else{
          this.wxImg = ''
        }
      } else {
        this.money = event.amount;
        this.chongzhi = event.id;
        this.getWxImg()
      }

    },
    changeMoney() {
      if(this.moneyInput>=0){
        this.money = this.moneyInput;
      }else{
        this.money = 0
        this.$message({
          type:'error',
          message:'充值余额不能小于零'
        })
      }
    },
    gaibianMoney(){
      if(this.money>0){
        this.getWxImg()
      }else{
        this.wxImg = ''
      }
    },
    // 获取微信支付二维码
    async getWxImg(){
      this.wxImg = ''
      try {
        const res = await getPayQRCode({
          money:this.money
        },this.headers);
        if(res.code==1){
          this.wxImg = res.data.path
        }else{
          this.$message({
            type:'error',
            message:res.msg
          })
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    // 充值余额
    async getWalleList() {
      try {
        // let params={
        //     page_no:1,
        //     page_size:1,
        //     type:'um',//流水明细类型 um-用户余额
        // }
        const res = await getRechargeAmountList(this.headers);
        if (res.code == 1) {
          this.payList = res.data;

          this.money = this.payList[0].amount
          this.getWxImg()
        }
      } catch (error) {
        console.log(error,"获取列表失败");
      }
    },
    // 获取充值配置公司详情
    async getPayDetail() {
      try {
        // rechargeConfig
        const res = await rechargeConfig(this.headers);
        if (res.code == 1) {
          this.payDetail = res.data;
          this.payDetail.payment_voucher=require(this.payDetail.payment_voucher)
        }
      } catch (error) {
        console.log(error,"失败");
      }
    },
    // 校验邮箱
    validFn() {
      if (this.formSubmit.email == "" || this.formSubmit.email == undefined) {
        this.$message({
          message: "请输入邮箱地址",
          type: "error",
        });
        return false;
      } else if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          this.formSubmit.email
        )
      ) {
        this.$message({
          message: "请输入正确的邮箱地址",
          type: "error",
        });
        return false;
      }
      return true;
    },
    async dgzzSubmit() {
      // 判断邮箱验证是否通过
      if (!this.validFn()) {
        return;
      }
      this.formSubmit.money = this.money;
      try {
        const res = await recharge(this.formSubmit, this.headers);
        if (res.code == 1) {
          this.$message({
            message: "提交成功，请耐心等待审核",
            type: "success",
          });
          this.dialogFormVisible = false;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error,"失败");
      }
    },
    async uploadImgSuccess(res) {
      if (res.code == 1) {
        this.formSubmit.voucher_file = res.data.uri;
      }
    },
  },
  mounted() {
    this.getWalleList();
    this.getPayDetail();
  },
};
</script>
    
<style style lang="scss" scoped>
.topNavigation {
  height: 100PX;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  background: #fff;
}

.Booking {
  background: #f9f9f9;
}
.typeArea {
  width: 1200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.el-breadcrumb {
  margin: 20px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  .el-breadcrumb__inner is-link {
    color: pink;
  }
}

:deep(.el-breadcrumb) {
  .el-breadcrumb__inner {
    color: #999999 !important;
  }
  .bread {
    span {
      color: #0073f5 !important;
    }
  }
}

.con {
//   height: 935px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  margin-bottom: 32px;
  .shangm {
    height: 120px;
    background-image: url("../../assets/images/上面.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;

    text-align: center;

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
    font-style: normal;
    text-transform: none;

    .ttt {
      font-size: 30px;
      padding-top: 23px;
    }
  }
  .xiam {
    padding: 40px 40px 0 40px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 12px;
    .biaoti {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #999999;
      font-style: normal;
      text-transform: none;
      margin-bottom: 16px;
    }

    .cz {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;

      .chong {
        width: 262px;
        height: 180px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);
        border-radius: 8px 8px 8px 8px;

        display: flex;
        flex-direction: column;
        align-items: center;

        border: 1px solid #fff;

        margin-right: 20px;
        margin-top: 24px;
        .num {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #fe3300;
          font-style: normal;
          text-transform: none;
          margin-top: 30px;
          margin-bottom: 12px;

          span {
            font-size: 40px;
          }

          .input {
            color: #999;
            margin-top: 19px;
          }

          .hong {
            color: #fe3300;
            :deep(.el-input) {
              width: 188px;
              input {
                width: 188px;
                font-size: 40px;
                color: #fe3300;
              }
            }
          }
          :deep(.el-input) {
            width: 88px;
            height: 34px;
            margin: 0;
            padding: 0;
            input {
              width: 88px;
              height: 34px;
              background: #fff;
              border-radius: 8px 8px 8px 8px;
              border: 0;
              margin: 0;
              padding: 0;

              font-size: 24px;
            }
            input::placeholder {
              color: #999;
            }
          }
        }
        .tiao {
          width: 80px;
          height: 4px;
          background: #0073f5;
        }

        .line {
          width: 222px;
          height: 1px;
          background: #eeeeee;
          border-radius: 0px 0px 0px 0px;
        }

        .buc {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
          font-style: normal;
          text-transform: none;

          margin-top: 24px;
          padding: 0 22px;
          box-sizing: border-box;
        }
      }

      .chongLast{
        margin-right: 0px;
      }

      .is-active {
        border: 1px solid #0073f5;
      }
    }

    .xian {
      width: 1120px;
      height: 1px;
      background: #eeeeee;
      margin: 40px 0;
    }
  }
}

.zhifu {
  background: #fff;
  padding-top: 48px;

  display: flex;
  .zf-left {
    display: flex;
    flex-direction: column;
    .elbutton {
      cursor: pointer;
      width: 140px;
      height: 60px;
      border-radius: 8px 8px 8px 8px;
      font-size: 16px;
      background: #edf6ff;
      color: #999999;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .yue {
      background: #0073f5;
      color: #fff;
      border: 0;
    }

    .img{
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }
  }

  .zf-right {
    margin-left: 132px;
    width: 800px;
    // text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    .qian {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      font-style: normal;
      text-transform: none;
      span {
        color: #fe3300;
      }

      .num {
        font-size: 40px;
      }
    }
    .ye {
      margin-top: 8px;
      // width: 355px;
      height: 40px;
      background: #edf6ff;
      border-radius: 8px 8px 8px 8px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #0073f5;
      text-align: center;
      font-style: normal;
      text-transform: none;
      line-height: 40px;
      padding: 0 16px;
    }

    .line {
      width: 800px;
      height: 1px;
      background: #eeeeee;
      border-radius: 0px 0px 0px 0px;
      margin-top: 40px;
      margin-bottom: 32px;
    }

    .xiaohao {
      display: flex;
      align-items: center;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      font-style: normal;
      text-transform: none;
      margin-top: 48px;
      margin-bottom: 50px;
      .wx {
        width: 160px;
        height: 160px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #09bb07;
      }

      .zfb {
        margin-left: 128px;
        width: 160px;
        height: 160px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #0073f5;
      }


      .el-image{
        width: 160px;
        height: 160px;
        border-radius: 8px 8px 8px 8px;
        
      }

      .imageNull{
          width: 100%;
          height: 100%;
          color: #C0C4CC;
          background: #F5F7FA;
          border-radius: 8px 8px 8px 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

      .wxzf {
        width: 160px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #09bb07;
        margin-top: 16px;
        
        display: flex;
        align-content: center;
        justify-content: center;

        span{
          margin-left: 6px;
        }
      }

      .zfbzf {
        width: 160px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #0073f5;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-top: 16px;
        i {
          margin-right: 6px;
        }
      }
    }

    .liji {
      width: 280px;
      height: 48px;
      background: #0073f5;
      border-radius: 12px 12px 12px 12px;
      border: 0;
      color: #fff;
      margin-top: 69px;
      margin-bottom: 48px;
    }
    .xieyi {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      font-style: normal;
      text-transform: none;

      span {
        color: #0073f5;
        cursor: pointer;
      }
      margin-bottom: 48px;
    }
    .first {
      width: 26px;
      height: 26px;
      background: #0073f5;
      color: #fff;
      text-align: center;
      line-height: 26px;
      border-radius: 50%;
      margin-right: 18px;
    }
    .huikuan {
      width: 585px;

      display: flex;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      font-style: normal;
      text-transform: none;
      margin-top: 49px;
      .tit {
        font-size: 18px;
        color: #333333;
        margin-bottom: 17px;
      }
      span {
        display: inline-block;
        margin-right: 80px;
        margin-bottom: 16px;
      }

      .btn {
        width: 87px;
        height: 34px;
        background: #0073f5;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        color: #fff;
        border: 0;
        cursor: pointer;
        margin-bottom: 48px;
      }
    }
  }
}

.dialog {
  .el-form {
    border-bottom: solid 1px #eee;
  }
  :deep(.el-dialog) {
    width: 480px;

    .el-form-item__content {
      display: flex;
    }
  }
  :deep(.el-input) {
    input {
      width: 320px;
      height: 48px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
    }
  }

  .quxiao {
    width: 100px;
    height: 40px;
    background: #f9f9f9;
    border-radius: 8px 8px 8px 8px;
    font-size: 14px;
    color: #999999;
    border: 0;
  }

  .queren {
    width: 100px;
    height: 40px;
    background: #0073f5;
    border-radius: 8px 8px 8px 8px;
    color: #fff;
    border: 0;
    margin-left: 16px;
  }
}

.YlBTN {
  margin-left: 10px;
  margin-top: 140px;
}
.upload {
  width: 320px;
  height: 168px;
  border-radius: 8px 8px 8px 8px;
}
.shangchuan {
  width: 320px;
  height: 168px;
  background: #f9f9f9;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #eeeeee;

  div {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    font-style: normal;
    text-transform: none;
    line-height: 14px;
  }

  img {
    width: 32px;
    height: 32px;

    margin-top: 52px;
  }
}

.yulanImg {
  :deep(.el-dialog) {
    width: 480px;
    img {
      width: 100%;
    }
  }
}
</style>